<template>
  <b-modal
    :id="'aicLegalConfirmationModal'"
    ref="aicLegalConfirmationModal"
    :title="$t('message.aicLegalConfirmation.title')"
    size="md"
    no-close-on-backdrop
    hide-footer>
    <div class="aic-legal-confirmation-modal">
      <div class="mb-4">
        <!-- eslint-disable vue/no-v-html -->
        <p
          class="mb-3"
          v-html="$t('message.aicLegalConfirmation.description')" />
      </div>
      <div class="modal-footer-actions">
        <coozzy-button
          design="transparent"
          class="mr-2 border"
          @click="cancel">
          {{ $t('message.generic.cancel') }}
        </coozzy-button>
        <coozzy-button
          design="green"
          @click="confirm">
          {{ $t('message.generic.confirm') }}
        </coozzy-button>
      </div>
    </div>
  </b-modal>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import { PropertyRecord } from '@/types/search/PropertyRecord'

export default Vue.extend({
  name: 'AicLegalConfirmationModal',
  components: {
    CoozzyButton
  },
  props: {
    selectedProperties: {
      type: Array as PropType<PropertyRecord[]>,
      default: () => []
    }
  },
  methods: {
    show() {
      this.$refs.aicLegalConfirmationModal.show()
    },
    hide() {
      this.$refs.aicLegalConfirmationModal.hide()
    },
    cancel() {
      this.hide()
      this.$emit('cancel')
    },
    confirm() {
      this.hide()
      this.$emit('confirm', this.selectedProperties)
    }
  }
})
</script>

<style lang="scss" scoped>
.aic-legal-confirmation-modal {
  .legal-links {
    margin-top: 1rem;

    .legal-link {
      color: #007bff;
      text-decoration: underline;
      font-weight: 500;

      &:hover {
        color: #0056b3;
        text-decoration: none;
      }
    }
  }
  .modal-footer-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #dee2e6;
  }
}
</style>
